import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';

import Login from './pages/Login.vue';
import PageNotFound from "./pages/PageNotFound";
import PageNoAccess from "./pages/PageNoAccess";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Home from "./pages/Home";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AdminDashboard from "./pages/AdminDashboard";
import Admin from "./layouts/Admin";
import AdminCompanies from "./pages/AdminCompanies";
import AdminUsers from "./pages/AdminUsers";
import AdminMyAccount from "./pages/AdminMyAccount";
import AdminUser from "./pages/AdminUser";
import AdminCompany from "./pages/AdminCompany";
import AdminItems from "./pages/AdminItems.vue";
import AdminListings from "./pages/AdminListings";
import AdminListing from "./pages/AdminListing";
import AdminBrands from "./pages/AdminBrands";
import AdminGenerateMarketingEmail from "./pages/AdminGenerateMarketingEmail.vue";
import AdminCategoryTypes from "./pages/AdminCategoryTypes";
import AdminTaxonomies from "./pages/AdminTaxonomies";
import AdminCategories from "./pages/AdminCategories";
import AdminProductionTypes from "./pages/AdminProductionTypes";
import AdminStrainTypes from "./pages/AdminStrainTypes";
import AdminStrains from "./pages/AdminStrains";
import AdminApplications from "./pages/AdminApplications";
import AdminApplication from "./pages/AdminApplication";
import AdminShipping from "./pages/AdminShipping";
import AdminShippers from "./pages/AdminShippers";
import AdminShipper from "./pages/AdminShipper";
import AdminShipperPrices from "./pages/AdminShipperPrices";
import AdminReports from "./pages/AdminReports";
import AdminReportSalesByDate from "./pages/AdminReportSalesByDate";
import AdminReportNewRepeatOrders from "./pages/AdminReportNewRepeatOrders";
import AdminReportSalesByCategory from "./pages/AdminReportSalesByCategory";
import AdminReportBuyersByDate from "./pages/AdminReportBuyersByDate";
import AdminReportSellersByDate from "./pages/AdminReportSellersByDate";
import AdminCategoryImages from "./pages/AdminCategoryImages";
import AdminNonMetrcTaxonomy from "./pages/AdminNonMetrcTaxonomy.vue";
import AdminPriceLimits from "./pages/AdminPriceLimits.vue";
import AdminPaymentMethodSettings from "./pages/AdminPaymentMethodSettings.vue";
import AdminStateLicenses from "./pages/StateLicenses.vue";
import StateLicenseDetailed from "./pages/StateLicenseDetailed.vue";
import AdminLicenseRegistry from "./pages/AdminLicenseRegistry.vue";
import AdminLicenseRegistryLicense from "./pages/AdminLicenseRegistryLicense.vue";
import AdminLicenseRegistryEntity from "./pages/AdminLicenseRegistryEntity.vue";
import AdminOrders from "./pages/AdminOrders.vue";
import AdminOrder from "./pages/AdminOrder.vue";
import AdminPricingPlans from "./pages/AdminPricingPlans.vue";
import AdminPricingPlanAdd from "./pages/AdminPricingPlanAdd.vue";
import AdminPricingPlanView from "./pages/AdminPricingPlanView.vue";
import AdminBilling from "./pages/AdminBilling.vue";
import AdminSubcategories from "./pages/AdminSubcategories.vue";
import AdminReportSellerActivity from "./pages/AdminReportSellerActivity.vue";
import AdminReportBuyersActivity from "./pages/AdminReportBuyersActivity.vue";
import AdminReportInventoryCoverage from "./pages/AdminReportInventoryCoverage.vue";
import AdminReportBrandsHealthScoring from "./pages/AdminReportBrandsHealthScoring.vue";
import AdminReportPerformanceAlerts from "./pages/AdminReportPerformanceAlerts.vue";
import AdminAppNotifications from "./pages/AdminAppNotifications.vue";
import AdminCtsScheduleUpload from "./pages/AdminCtsScheduleUpload.vue";
import AdminCtsFleetUpload from "./pages/AdminCtsFleetUpload.vue";
import AdminReportAccountBillingStatus from "./pages/AdminReportAccountBillingStatus.vue";
import AdminReportAccountMonthlyRevenue from "./pages/AdminReportAccountMonthlyRevenue.vue";
import AdminReportIncompleteApplications from "./pages/AdminReportIncompleteApplications.vue";
import AdminReportPublicMenuSharing from "./pages/AdminReportPublicMenuSharing.vue";
import AdminUniversalDirectory from "./pages/AdminUniversalDirectory.vue";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                is_auth: false,
                title: 'Welcome'
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                is_auth: false,
                title: 'Login'
            }
        },
        {
            path: '/password/forgot',
            name: 'forgot-password',
            component: ForgotPassword,
            meta: {
                is_auth: false,
                title: 'Forgot Password'
            }
        },
        {
            path: '/password/reset/:token',
            name: 'reset-password',
            component: ResetPassword,
            meta: {
                is_auth: false,
                title: 'Reset Password'
            }
        },
        {
            path: '/terms-conditions',
            name: 'terms-conditions',
            component: TermsAndConditions,
            meta: {
                is_auth: false,
                title: 'Terms & Conditions'
            }
        },
        {
            path: '/privacy-policy',
            name: 'privacy-policy',
            component: PrivacyPolicy,
            meta: {
                is_auth: false,
                title: 'Privacy Policy'
            }
        },
        //Admin routes.
        {
            path: '/admin',
            name: 'admin',
            redirect: '/admin/dashboard',
            component: Admin,
            meta: {
                is_auth: true,
                title: 'Dashboard',
                auth_roles: ['admin']
            },
            children: [
                { path: '/admin/activity-checklists/definitions/:definition([0-9]+)/companies', name: 'admin-checklist-companies', component: () => import('./pages/AdminChecklistCompanies.vue'), meta: { is_auth: true, title: 'Checklist companies', auth_roles: ['admin'], checklist_super_admin: true } },
                { path: '/admin/activity-checklists', name: 'admin-activity-checklists', component: () => import('./pages/AdminActivityChecklists.vue'), meta: { is_auth: true, title: 'Activity checklists', auth_roles: ['admin'], checklist_super_admin: true } },
                { path: '/admin/activity-checklists/definitions/:definition([0-9]+)/versions/:version([0-9]+)', name: 'admin-activity-checklist-version', component: () => import('./pages/AdminActivityChecklists.vue'), meta: { is_auth: true, title: 'Checklist version', auth_roles: ['admin'], checklist_super_admin: true } },
                { path: '/admin/activity-checklist-periods', name: 'admin-activity-periods', component: () => import('./pages/AdminActivityPeriods.vue'), meta: { is_auth: true, title: 'Checklist periods', auth_roles: ['admin'], checklist_super_admin: true } },
                { path: '/admin/activity-checklist-periods/:period([0-9]+)', name: 'admin-activity-period', component: () => import('./pages/AdminActivityPeriods.vue'), meta: { is_auth: true, title: 'Checklist evidence', auth_roles: ['admin'], checklist_super_admin: true } },
                {
                    path: '/admin/ai-usage',
                    name: 'admin-ai-usage',
                    component: () => import('./pages/AdminAiUsage.vue'),
                    meta: {
                        is_auth: true,
                        title: 'AI Usage',
                        auth_roles: ['admin'],
                        admin_permissions: ['billing_read']
                    },
                },
                {
                    path: '/admin/dashboard',
                    name: 'admin-dashboard',
                    component: AdminDashboard,
                    meta: {
                        is_auth: true,
                        title: 'Dashboard',
                        auth_roles: ['admin']
                    },
                },
                {
                    path: 'applications',
                    name: 'admin-applications',
                    component: AdminApplications,
                    meta: {
                        is_auth: true,
                        title: 'Pending Applications',
                        auth_roles: ['admin'],
                        has_search: true
                    },
                },
                {
                    path: 'applications/:id',
                    props: true,
                    name: 'admin-application',
                    component: AdminApplication,
                    meta: {
                        is_auth: true,
                        title: 'Manage Application',
                        auth_roles: ['admin']
                    },
                },
                {
                    path: '/admin/brands',
                    name: 'admin-brands',
                    component: AdminBrands,
                    meta: {
                        is_auth: true,
                        title: 'Brands',
                        auth_roles: ['admin'],
                        has_search: true,
                        admin_permissions: ['brand_read']
                    },
                },
                {
                    path: '/admin/generate-marketing-email',
                    name: 'admin-generate-marketing-email',
                    component: AdminGenerateMarketingEmail,
                    meta: {
                        is_auth: true,
                        title: 'Generate Marketing Email',
                        auth_roles: ['admin'],
                        admin_permissions: ['marketing_email']
                    },
                },
                {
                    path: '/admin/taxonomies',
                    name: 'admin-taxonomies',
                    redirect: '/admin/taxonomies/category-types',
                    component: AdminTaxonomies,
                    children: [
                        {
                            path: '/admin/taxonomies/category-types',
                            name: 'admin-category-types',
                            component: AdminCategoryTypes,
                            meta: {
                                is_auth: true,
                                title: 'Category Types',
                                auth_roles: ['admin'],
                                has_search: true,
                                admin_permissions: ['taxonomy_read']
                            },
                        },
                        {
                            path: '/admin/taxonomies/categories',
                            name: 'admin-categories',
                            component: AdminCategories,
                            meta: {
                                is_auth: true,
                                title: 'Categories',
                                auth_roles: ['admin'],
                                has_search: true,
                                admin_permissions: ['taxonomy_read']
                            },
                        },
                        {
                            path: '/admin/taxonomies/subcategories',
                            name: 'admin-subcategories',
                            component: AdminSubcategories,
                            meta: {
                                is_auth: true,
                                title: 'Subcategories',
                                auth_roles: ['admin'],
                                has_search: true,
                                admin_permissions: ['taxonomy_read']
                            },
                        },
                        {
                            path: '/admin/taxonomies/production-types',
                            name: 'admin-production-types',
                            component: AdminProductionTypes,
                            meta: {
                                is_auth: true,
                                title: 'Production Types',
                                auth_roles: ['admin'],
                                has_search: true,
                                admin_permissions: ['taxonomy_read']
                            },
                        },
                        {
                            path: '/admin/taxonomies/strain-types',
                            name: 'admin-strain-types',
                            component: AdminStrainTypes,
                            meta: {
                                is_auth: true,
                                title: 'Strain Types',
                                auth_roles: ['admin'],
                                has_search: true,
                                admin_permissions: ['taxonomy_read']
                            },
                        },
                        {
                            path: '/admin/taxonomies/strains',
                            name: 'admin-strains',
                            component: AdminStrains,
                            meta: {
                                is_auth: true,
                                title: 'Strains',
                                auth_roles: ['admin'],
                                has_search: true,
                                admin_permissions: ['taxonomy_read']
                            },
                        },
                        {
                            path: '/admin/taxonomies/category-images',
                            name: 'admin-category-images',
                            component: AdminCategoryImages,
                            meta: {
                                is_auth: true,
                                title: 'Category Images',
                                auth_roles: ['admin'],
                                has_search: false,
                                admin_permissions: ['taxonomy_read']
                            },
                        },
                        {
                            path: '/admin/taxonomies/non-metrc',
                            name: 'admin-non-metrc-taxonomy',
                            component: AdminNonMetrcTaxonomy,
                            meta: {
                                is_auth: true,
                                title: 'Non-METRC Taxonomy',
                                auth_roles: ['admin'],
                                has_search: true,
                                admin_permissions: ['taxonomy_read']
                            },
                        }
                    ]
                },
                {
                    path: '/admin/companies',
                    name: 'admin-companies',
                    component: AdminCompanies,
                    meta: {
                        is_auth: true,
                        title: 'Companies',
                        auth_roles: ['admin'],
                        has_search: true,
                        admin_permissions: ['company_read']
                    },
                },
                {
                    path: '/admin/companies/:id',
                    props: true,
                    name: 'admin-company',
                    component: AdminCompany,
                    meta: {
                        is_auth: true,
                        title: 'Manage Company',
                        auth_roles: ['admin'],
                        admin_permissions: ['company_read']
                    },
                },
                {
                    path: '/admin/my-account',
                    name: 'admin-my-account',
                    component: AdminMyAccount,
                    meta: {
                        is_auth: true,
                        title: 'My Account',
                        auth_roles: ['admin']
                    },
                },
                {
                    path: '/admin/users',
                    name: 'admin-users',
                    component: AdminUsers,
                    meta: {
                        is_auth: true,
                        title: 'Users',
                        auth_roles: ['admin'],
                        has_search: true,
                        admin_permissions: ['user_read']
                    },
                },
                {
                    path: '/admin/users/:id',
                    props: true,
                    name: 'admin-user',
                    component: AdminUser,
                    meta: {
                        is_auth: true,
                        title: 'Edit User',
                        auth_roles: ['admin'],
                        admin_permissions: ['user_read']
                    },
                },
                {
                    path: '/admin/listings',
                    name: 'admin-listings',
                    component: AdminListings,
                    meta: {
                        is_auth: true,
                        title: 'Listings',
                        auth_roles: ['admin'],
                        has_search: true,
                        admin_permissions: ['listing_read']
                    },
                },
                {
                    path: '/admin/listings/:id',
                    props: true,
                    name: 'admin-listing',
                    component: AdminListing,
                    meta: {
                        is_auth: true,
                        title: 'Listing',
                        auth_roles: ['admin'],
                        admin_permissions: ['listing_read']
                    },
                },
                {
                    path: '/admin/items',
                    name: 'admin-items',
                    component: AdminItems,
                    meta: {
                        is_auth: true,
                        title: 'Items',
                        auth_roles: ['admin'],
                        has_search: true
                    },
                },
                {
                    path: '/admin/orders',
                    name: 'admin-orders',
                    component: AdminOrders,
                    meta: {
                        is_auth: true,
                        title: 'Orders',
                        auth_roles: ['admin'],
                        admin_permissions: ['order_read']
                    },
                },
                {
                    path: '/admin/orders/:id',
                    props: true,
                    name: 'admin-order',
                    component: AdminOrder,
                    meta: {
                        is_auth: true,
                        title: 'Order',
                        auth_roles: ['admin'],
                        admin_permissions: ['order_read']
                    }
                },
                {
                    path: '/admin/cts-schedule-upload',
                    name: 'admin-cts-schedule-upload',
                    component: AdminCtsScheduleUpload,
                    meta: {
                        is_auth: true,
                        title: 'CTS Schedule Upload',
                        auth_roles: ['admin']
                    },
                },
                {
                    path: '/admin/cts-fleet-upload',
                    name: 'admin-cts-fleet-upload',
                    component: AdminCtsFleetUpload,
                    meta: {
                        is_auth: true,
                        title: 'CTS Driver & Vehicle Upload',
                        auth_roles: ['admin']
                    },
                },
                {
                    path: '/admin/shipping',
                    name: 'admin-shipping',
                    redirect: '/admin/shipping/shippers',
                    component: AdminShipping,
                    children: [
                        {
                            path: '/admin/shipping/shippers',
                            name: 'admin-shippers',
                            component: AdminShippers,
                            meta: {
                                is_auth: true,
                                title: 'Shippers',
                                auth_roles: ['admin'],
                                has_search: true,
                                admin_permissions: ['shipper_read']
                            },
                        },
                        {
                            path: '/admin/shipping/shippers/:id(\\d+)',
                            props: true,
                            name: 'admin-shipper',
                            component: AdminShipper,
                            meta: {
                                is_auth: true,
                                title: 'Shipper',
                                auth_roles: ['admin'],
                                admin_permissions: ['shipper_read']
                            },
                        },
                        {
                            path: '/admin/shipping/shippers/prices',
                            name: 'admin-shipper-prices',
                            component: AdminShipperPrices,
                            meta: {
                                is_auth: true,
                                title: 'Shipper Prices',
                                auth_roles: ['admin'],
                                has_search: true,
                                admin_permissions: ['shipper_read']
                            },
                        },
                    ]
                },
                {
                    path: '/admin/reports',
                    name: 'admin-reports',
                    redirect: '/admin/reports/sales-by-date',
                    component: AdminReports,
                    children: [
                        {
                            path: '/admin/reports/sales-by-date',
                            name: 'admin-report-sales-by-date',
                            component: AdminReportSalesByDate,
                            meta: {
                                is_auth: true,
                                title: 'Sales by Date',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                        {
                            path: '/admin/reports/new-repeat-orders',
                            name: 'admin-report-new-repeat-orders',
                            component: AdminReportNewRepeatOrders,
                            meta: {is_auth: true, title: 'New & Repeat Orders', auth_roles: ['admin'], admin_permissions: ['report_read']}
                        },
                        {
                            path: '/admin/reports/sales-by-category',
                            name: 'admin-report-sales-by-category',
                            component: AdminReportSalesByCategory,
                            meta: {
                                is_auth: true,
                                title: 'Sales by Category',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                        {
                            path: '/admin/reports/sellers-by-date',
                            name: 'admin-report-sellers-by-date',
                            component: AdminReportSellersByDate,
                            meta: {
                                is_auth: true,
                                title: 'Sellers by Date',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                        {
                            path: '/admin/reports/buyers-by-date',
                            name: 'admin-report-buyers-by-date',
                            component: AdminReportBuyersByDate,
                            meta: {
                                is_auth: true,
                                title: 'Buyers by Date',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                        {
                            path: '/admin/reports/seller-activity',
                            name: 'admin-report-seller-activity',
                            component: AdminReportSellerActivity,
                            meta: {
                                is_auth: true,
                                title: 'Seller Activity',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                        {
                            path: '/admin/reports/buyers-activity',
                            name: 'admin-report-buyers-activity',
                            component: AdminReportBuyersActivity,
                            meta: {
                                is_auth: true,
                                title: 'Buyers Activity',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                        {
                            path: '/admin/reports/inventory-coverage',
                            name: 'admin-report-inventory-coverage',
                            component: AdminReportInventoryCoverage,
                            meta: {
                                is_auth: true,
                                title: 'Inventory Coverage',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                        {
                            path: '/admin/reports/performance-alerts',
                            name: 'admin-report-performance-alerts',
                            component: AdminReportPerformanceAlerts,
                            meta: {
                                is_auth: true,
                                title: 'Performance Alerts',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                        {
                            path: '/admin/reports/admin-report-brand-health-scoring',
                            name: 'admin-report-brand-health-scoring',
                            component: AdminReportBrandsHealthScoring,
                            meta: {
                                is_auth: true,
                                title: 'Brand Health Scoring',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                        {
                            path: '/admin/reports/admin-report-account-billing-status',
                            name: 'admin-report-account-billing-status',
                            component: AdminReportAccountBillingStatus,
                            meta: {
                                is_auth: true,
                                title: 'Account Billing Status',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                        {
                            path: '/admin/reports/admin-report-account-monthly-revenue',
                            name: 'admin-report-account-monthly-revenues',
                            component: AdminReportAccountMonthlyRevenue,
                            meta: {
                                is_auth: true,
                                title: 'Account Monthly Revenues',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                        {
                            path: '/admin/reports/admin-report-incomplete-applications',
                            name: 'admin-report-incomplete-applications',
                            component: AdminReportIncompleteApplications,
                            meta: {
                                is_auth: true,
                                title: 'Incomplete Applications',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                        {
                            path: '/admin/reports/admin-report-public-menu-sharing',
                            name: 'admin-report-public-menu-sharing',
                            component: AdminReportPublicMenuSharing,
                            meta: {
                                is_auth: true,
                                title: 'Public Menu Sharing',
                                auth_roles: ['admin'],
                                admin_permissions: ['report_read']
                            },
                        },
                    ]
                },
                {
                    path: '/admin/price-limits',
                    name: 'admin-price-limits',
                    component: AdminPriceLimits,
                    title: 'Price Limits',
                    meta: {
                        admin_permissions: ['price_limit_read']
                    }
                },
                {
                    path: '/admin/payment-method-settings',
                    name: 'admin-payment-method-settings',
                    component: AdminPaymentMethodSettings,
                    title: 'Payment Methods'
                },
                {
                    path: '/admin/pricing-plans',
                    name: 'admin-pricing-plans',
                    component: AdminPricingPlans,
                    title: 'Pricing Plans',
                    meta: {
                        admin_permissions: ['pricing_plan_read']
                    }
                },
                {
                    path: '/admin/pricing-plans/add',
                    name: 'admin-pricing-plan-add',
                    component: AdminPricingPlanAdd,
                    title: 'Add Pricing Plan',
                    meta: {
                        admin_permissions: ['pricing_plan_create']
                    }
                },
                {
                    path: '/admin/pricing-plans/:id(\\d+)',
                    props: true,
                    name: 'admin-pricing-plan-view',
                    component: AdminPricingPlanView,
                    title: 'View Pricing Plan',
                    meta: {
                        admin_permissions: ['pricing_plan_read']
                    }
                },
                {
                    path: '/admin/billing',
                    name: 'admin-billing',
                    component: AdminBilling,
                    title: 'Billing',
                    meta: {
                        admin_permissions: ['billing_read']
                    }
                },
                {
                    path: '/admin/state-licenses',
                    name: 'admin-state-licenses',
                    component: AdminStateLicenses,
                    meta: {
                        is_auth: true,
                        title: 'State Licenses',
                        auth_roles: ['admin'],
                        has_search: true,
                        admin_permissions: ['state_license_read']
                    },
                },
                {
                    path: '/admin/state-licenses/:id',
                    props: true,
                    name: 'admin-state-license-detail',
                    component: StateLicenseDetailed,
                    meta: {
                        is_auth: true,
                        title: 'State License Detail',
                        auth_roles: ['admin'],
                        has_search: false,
                        admin_permissions: ['state_license_read']
                    },
                },
                {
                    path: '/admin/license-registry',
                    name: 'admin-license-registry',
                    component: AdminLicenseRegistry,
                    meta: {
                        is_auth: true,
                        title: 'License Registry',
                        auth_roles: ['admin'],
                        admin_permissions: ['license_registry_read']
                    },
                },
                {
                    path: '/admin/license-registry/licenses/:id',
                    props: true,
                    name: 'admin-license-registry-license',
                    component: AdminLicenseRegistryLicense,
                    meta: {
                        is_auth: true,
                        title: 'License Registry',
                        auth_roles: ['admin'],
                        admin_permissions: ['license_registry_read']
                    },
                },
                {
                    path: '/admin/license-registry/entities/:id',
                    props: true,
                    name: 'admin-license-registry-entity',
                    component: AdminLicenseRegistryEntity,
                    meta: {
                        is_auth: true,
                        title: 'License Registry',
                        auth_roles: ['admin'],
                        admin_permissions: ['license_registry_read']
                    },
                },
                {
                    path: '/admin/app-notifications',
                    name: 'admin-app-notifications',
                    component: AdminAppNotifications,
                    meta: {
                        is_auth: true,
                        title: 'App Notifications',
                        auth_roles: ['admin'],
                        admin_permissions: ['app_notification_read']
                    },
                },
                {
                    path: '/admin/universal-directory',
                    name: 'admin-universal-directory',
                    component: AdminUniversalDirectory,
                    meta: {
                        is_auth: true,
                        title: 'Universal Directory',
                        auth_roles: ['admin'],
                        admin_permissions: ['user_read', 'company_read', 'state_license_read']
                    },
                }
            ]
        },
        //Access denied page.
        {
            path: '/access-denied',
            name: 'access-denied',
            component: PageNoAccess,
            meta: {
                is_auth: true,
                title: 'Access Denied'
            }
        },
        //Last one route for 404.
        {
            path: '*',
            component: PageNotFound,
            meta: {
                title: 'Page Not Found'
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    store.commit('current/setSearch', '');
    if (typeof to.meta.title === 'string') {
        document.title = to.meta.title + ' | Green Lists';
    }
    if (typeof to.meta.is_auth === 'boolean') {
        if (!to.meta.is_auth && store.state.auth.is_user_logged_in) {
            if (!store.state.auth.user.role || store.state.auth.user.role.code !== 'admin') {
                //window.location.href = process.env.MIX_USER_APP_URL;
            } else {
                next({name: 'admin-dashboard'});
            }
            return;
        } else if (to.meta.is_auth && !store.state.auth.is_user_logged_in) {
            next({name: 'login'})
            return;
        } else if (to.meta.is_auth && typeof to.meta.auth_roles !== 'undefined' && to.meta.auth_roles.length > 0) {
            if (to.meta.auth_roles.indexOf(store.state.auth.user.role.code) < 0) {
                next({name: 'access-denied'});
                return;
            }
        }
    }

    if (to.meta.checklist_super_admin && !store.state.auth.user.is_super_admin) {
        next({name: 'access-denied'});
        return;
    }
    next();
});

export default router;
